export const MAX_MILEAGE_TO_SHOW_BADGE = 100000;
